export const receitas = [
  {
    id: 1,
    title: "Batata recheada com charque e sour cream",
    image: "/images/receitas/batata-recheada.webp",
    rendimento: "6 porções",
    tempo_preparo: "20 minutos",
    ingredients: [
      "6 batatas",
      "500 g de charque cozida e desfiada",
      "Azeite a gosto",
      "Alho a gosto",
      "Cebola a gosto",
      "Manteiga a gosto",
      "Sal a gosto",
      "Sour cream a gosto",
      "Salsa fresca a gosto",
      "Cebolinha fresca a gosto",
    ],
    modo_preparo: [
      "Cozinhe as batatas com casca até que amoleçam, mas fiquem firmes.",
      "Enquanto isso, refogue a charque com azeite, alho e cebola.",
      "Reserve.",
      "Retire a polpa da batata, como se fosse fazer uma canoa.",
      "Tempere as batatas com manteiga e sal.",
      "Leve ao forno rapidamente, para derreter a manteiga e dourar a casca das batatas.",
      "Retire do forno e recheie com a charque.",
      "Finalize com o sour cream, a salsa e a cebolinha.",
      "Bom apetite.",
    ],
  },
  {
    id: 2,
    title: "Arroz com charque (arroz carreteiro)",
    image: "/images/receitas/arroz-carreteiro.webp",
    rendimento: "5 porções",
    tempo_preparo: "50 minutos",
    ingredients: [
      "2 xícaras de chá de arroz (400 gramas)",
      "4 xícaras de chá de água (800 ml)",
      "100 gramas de charque dessalgada e desfiada",
      "250 gramas de linguiça calabresa",
      "70 gramas de bacon em cubos",
      "2 colheres de sopa de óleo",
      "1/2 cebola (60 gramas)",
      "2 dentes de alho (10 gramas)",
      "2 folhas de louro",
      "1/2 xícara de chá de salsinha fresca (50 gramas)",
      "Pimenta-do-reino a gosto",
      "Caldo 1 limão (opcional)",
    ],
    modo_preparo: [
      "O arroz carreteiro tradicional é feito com charque. É possível substituir por sobras do churrasco bem picadinhas ou desfiadas;",
      "Em uma chaleira, coloque 4 xícaras de chá de água para ferver em fogo baixo;",
      "Em uma tábua, descasque e fatie a cebola em meia-lua fina. Se preferir, corte em cubinhos;",
      "Pique os alhos, não precisa ser tão fininho. Se quiser, aumente a quantidade;",
      "Corte a linguiça calabresa em meia-lua, ou em cubinhos médios (do mesmo tamanho que você picou o bacon);",
      "Leve uma panela ao fogo médio e aqueça o óleo. Adicione o bacon e a linguiça calabresa. Frite por aproximadamente 5 minutos, ou até dourar levemente. Mexa de vez em quando para não queimar;",
      "Despeje a cebola e refogue até ela ficar transparente. Junte o alho e mexa por aproximadamente 1 minuto para perfumar;",
      "Incorpore a charque, as folhas de louro e o arroz. Mexa tudo até ficar bem misturado. Refogue por cerca de um minuto;",
      "Quando perceber que os ingredientes começaram a grudar no fundo da panela, coloque a água quente e misture bem por 30 segundos. Tampe metade da panela e deixe cozinhando;",
      "Após cerca de 20 minutos, quando a água tiver secado por completo, desligue o fogo. Espete um garfo no arroz, separando cuidadosamente os grãos, para verificar se a água realmente secou;",
      "Tampe a panela e deixe o arroz descansar por, pelo menos, 5 minutos. Os grãos chegarão ao ponto ideal terminando de cozinhar no próprio vapor;",
      "Lave a salsinha, fatie em pedaços pequenos e salpique no arroz. Tempere com pimenta-do-reino a gosto e caldo de limão;",
      "Pronto! Aproveite o seu arroz carreteiro com tudo que tem direito. Bom apetite!",
    ],
  },
  {
    id: 3,
    title: "Purê de mandioca com charque",
    image: "/images/receitas/pure-de-mandioca.webp",
    rendimento: "4 a 6 porções",
    tempo_preparo: "60 minutos",
    ingredients: [
      "2 kg de mandioca descascada e cortada em pedaços menores",
      "4 colheres de sopa de manteiga",
      "5 colheres de sopa de leite em pó",
      "Sal a gosto",
      "3/4 de xícara de chá de manteiga de garrafa",
      "1 cebola grande cortada em tiras",
      "500 gramas de charque dessalgada, cozida e desfiada",
      "1 xícara de chá de cheiro-verde picado",
      "Coentro picado a gosto (opcional)",
      "1 cebola cortada em rodelas",
      "1/4 de xícara de chá de azeite",
      "2 xícaras de chá de queijo mussarela ralado",
      "100 gramas de queijo parmesão ralado",
    ],
    modo_preparo: [
      "Em uma panela, coloque a mandioca, ligue o fogo médio e deixe cozinhar até ficar macia (cerca de 20 minutos).",
      "Reserve 500 ml do caldo do cozimento, retire os talos, os fiapos da mandioca e amasse ela até formar um purê.",
      "Adicione a manteiga e misture bem. Reserve.",
      "Coloque o leite em pó no caldo do cozimento e misture até dissolver tudo.",
      "Despeje, gradualmente, na mandioca e vá misturando.",
      "Acerte o sal e misture até ficar um purê homogêneo. Reserve.",
      "Em outra panela, esquente a manteiga de garrafa e refogue a cebola até dourar.",
      "Acrescente a charque e refogue por 6 minutos.",
      "Desligue o fogo, junte o cheiro-verde, o coentro, misture e reserve.",
      "Em um refratário, forre o fundo com as rodelas de cebola e regue com azeite.",
      "Por cima, despeje metade do purê e espalhe bem.",
      "Coloque o refogado de charque, espalhando bem e cubra com o queijo ralado.",
      "Cubra com o restante do purê e polvilhe parmesão ralado por cima.",
      "Leve ao forno preaquecido a 180 ºC por cerca de 20 minutos.",
      "Agora é só servir. Bom apetite.",
    ],
  },
  {
    id: 4,
    title: "Arroz de charque caprichado",
    image: "/images/receitas/arroz-de-charque-caprichado.webp",
    rendimento: "4 porções",
    tempo_preparo: "40 minutos",
    ingredients: [
      "1 pacote de charque",
      "1 gomo de calabresa",
      "100 gramas de bacon picado",
      "2 dentes de alho picado",
      "1 cebola picada",
      "Pimenta-do-reino a gosto",
      "Sal a gosto",
      "3 copos de 200 ml de arroz",
      "6 copos de 200 ml de água",
    ],
    modo_preparo: [
      "Refogue um pedaço de bacon e coloque a calabresa picada.",
      "Refogue e adicione o alho e a cebola.",
      "Coloque a charque e mexa bem.",
      "Adicione o arroz e tempere com pimenta-do-reino.",
      "Deixe o arroz refogar por um tempo e coloque a água.",
      "Quando ferver, abaixe o fogo e deixe cozinhar.",
      "Decore como preferir.",
      "Agora é só servir! Bom apetite.",
    ],
  },
  {
    id: 5,
    title: "charque com abóbora",
    image: "/images/receitas/charque-com-abobora-capa.webp",
    rendimento: "4 porções",
    tempo_preparo: "45 minutos",
    ingredients: [
      "1 cebola picada",
      "3 dentes de alho",
      "200 gramas de charque dessalgada",
      "1/2 abóbora cabotiá em cubos",
      "1 colher de sobremesa de açúcar",
      "1 colher de chá de sal",
      "1/4 de xícara de chá de água",
      "Salsinha a gosto",
      "Sal e pimenta-do-reino a gosto",
      "Azeite para refogar",
    ],
    modo_preparo: [
      "Reúna todos os ingredientes;",
      "Leve a charque para cozinhar na panela de pressão por 15 a 30 minutos até ficar macia;",
      "Depois de cozida, retire a pressão e descarte a água do cozimento;",
      "Em uma panela, aqueça o azeite e refogue a cebola, o alho e a carne até ficarem dourados;",
      "Depois, despeje a abóbora e adicione um pouco de água para cozinhar;",
      "Ajuste os temperos e acrescente o açúcar. Misture bem;",
      "Deixe cozinhar até que a abóbora amoleça;",
      "Sirva e bom apetite!",
    ],
  },
  {
    id: 6,
    title: "Risoto de charque",
    image: "/images/receitas/risoto-de-charque.webp",
    rendimento: "2 porções",
    tempo_preparo: "30 minutos",
    ingredients: [
      "Azeite a gosto",
      "2 colheres de sopa de manteiga",
      "1 cebola picada",
      "1 xícara de chá de arroz carnaroli (ou arbóreo)",
      "1/2 xícara de chá de vinho branco",
      "1 xícara de chá de charque dessalgada e desfiada",
      "Cerca de 1,5 litros de caldo de legumes",
      "1/2 colher de chá de açafrão",
      "Sal e pimenta-do-reino a gosto",
      "1/2 xícara de chá de queijo parmesão ralado",
      "1 colher de sopa de salsinha picada",
    ],
    modo_preparo: [
      "Reúna todos os ingredientes.",
      "Em uma panela, adicione 1 colher de manteiga, o azeite, a cebola e refogue até ficar transparente.",
      "Acrescente o arroz e refogue por mais alguns minutos.",
      "Despeje o vinho e deixe evaporar.",
      "Jogue a charque, misture e, gradualmente, vá adicionando o caldo de legumes e mexa (conforme o caldo vai secando, vá colocando mais uma concha e mexendo).",
      "Acrescente o açafrão, o sal, a pimenta, o queijo parmesão, a salsinha e misture bem.",
      "Desligue o fogo, coloque a outra colher de manteiga e misture.",
      "Agora é só servir.",
    ],
  },
  {
    id: 7,
    title: "Cuscuz com charque e queijo",
    image: "/images/receitas/cuscuz-com-charque-e-queijo.webp",
    rendimento: "1 porção",
    tempo_preparo: "30 minutos",
    ingredients: [
      "1 xícara de chá de flocão de milho",
      "1/2 xícara de chá de água",
      "Sal a gosto",
      "charque desfiada a gosto",
      "Queijo fatiado a gosto",
    ],
    modo_preparo: [
      "Em uma tigela, misture o flocão, a água e o sal e reserve por 10 minutos.",
      "Passado o tempo, coloque água até metade do limite da cuscuzeira.",
      "Adicione metade da mistura de flocão e, por cima, espalhe a charque e o queijo.",
      "Cubra com o restante do flocão, tampe e cozinhe em fogo baixo por 10 minutos.",
      "Desligue o fogo, aguarde 3 minutos e desenforme o cuscuz em um prato.",
      "Agora é só servir! Bom apetite.",
    ],
  },
  {
    id: 8,
    title: "Arroz cremoso de charque",
    image: "/images/receitas/arroz-cremoso-de-charque.webp",
    rendimento: "5 porções",
    tempo_preparo: "31 minutos",
    ingredients: [
      "Azeite a gosto",
      "500 gramas de charque dessalgado",
      "1 cebola",
      "3 dentes de alho",
      "1/2 pimenta-dedo-de-moça",
      "2 xícaras de chá de arroz",
      "5 xícaras de chá de água",
      "200 gramas de tomate cereja",
      "200 gramas de queijo coalho",
    ],
    modo_preparo: [
      "Em uma panela, coloque um fio de azeite e frite o charque.",
      "Adicione a cebola, o alho, a pimenta-dedo-de-moça e deixe dar uma leve dourada.",
      "Acrescente o arroz, 4 xícaras de água e deixe cozinhar até ficar quase seco.",
      "Junte o restante da água, o queijo, o tomate cereja cortado ao meio e tampe a panela.",
      "Em uma frigideira, coloque o queijo coalho cortado em cubos e doure de todos os lados.",
      "Sirva com o arroz e aproveite.",
    ],
  },
];
